module.exports = __webpack_public_path__ + "static/media/img14_LV.2944b925.png";